import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/api";
import Storage from "../../utils/storage";


// RESET PASSWORD
export const resetStart = () => ({
    type: UserActions.USER_RESET_PASSWORD_START
})

export const resetSuccess = payload => ({
    type: UserActions.USER_RESET_PASSWORD_SUCCESS,
    payload
})

export const resetFailure = payload => ({
    type: UserActions.USER_RESET_PASSWORD_FAILURE,
    payload
})

// SEND NEW PASSWORD
export const sendNewPasswordStart = () => ({
    type: UserActions.USER_SEND_NEW_PASSWORD_START
})

export const sendNewPasswordSuccess = payload => ({
    type: UserActions.USER_SEND_NEW_PASSWORD_SUCCESS,
    payload
})

export const sendNewPasswordFailure = payload => ({
    type: UserActions.USER_SEND_NEW_PASSWORD_FAILURE,
    payload
})

export const clearPasswordResetState = () => ({
    type: UserActions.CLEAR_RESET_PASSWORD_STATE,
});

export const resetPassword = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(resetStart());
    API.post("auth/password/reset", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(resetSuccess(data.success));
        } else {
            dispatch(resetFailure(data));
        }
    })
}

export const sendNewPassword = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(sendNewPasswordStart());
    API.post("auth/password/reset/verify", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(sendNewPasswordSuccess(data.success));
        } else {
            dispatch(sendNewPasswordFailure(data));
        }
    })
}
